export default function ModerationResult({ moderation }) {
  if (!moderation) return null;

  if (moderation.kind) {
    return (
      <div className="rounded-xl bg-teal-50 border border-teal-500/40 px-4 py-3 text-sm text-teal-700">
        Kind enough &mdash; sending it now.
      </div>
    );
  }

  return (
    <div className="rounded-xl bg-orange-100/60 border border-orange-500/40 px-4 py-3 text-sm text-navy-900">
      <p className="font-semibold mb-1">This one didn&rsquo;t feel kind enough.</p>
      {moderation.reason && (
        <p className="text-navy-700">{moderation.reason}</p>
      )}
      <p className="text-navy-500 mt-2">
        Try rewriting it as a specific, generous compliment.
      </p>
    </div>
  );
}
